import '../../src/article_good_button'
import '../../src/create_markup_bread_crumb_list'
import '../../src/jump_inner_link'
import '../../src/preview_buttons'
import '../../src/toc_door'
import '../../src/video_autoplay'

var componentRequireContext = require.context("components", true, /front\/common\/FloatingPromotionBanner|front\/youtube\/.*/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
